/**
 * Get current user from localStorage
 * @returns {object|null} User object or null if not logged in
 */
export const getCurrentUser = () => {
  const userStr = localStorage.getItem("user");
  return userStr ? JSON.parse(userStr) : null;
};

/**
 * Check if user is authenticated
 * @returns {boolean} True if user has valid token
 */
export const isAuthenticated = () => {
  return !!localStorage.getItem("access_token");
};

/**
 * Get organization ID
 * @returns {string|null} Organization ID or null
 */
export const getOrgId = () => {
  return localStorage.getItem("org_id");
};

/**
 * Get user role
 * @returns {string|null} User role or null
 */
export const getUserRole = () => {
  return localStorage.getItem("user_role");
};
